import { asiakas_fetch } from "../asiakas/AsiakasFunctions";
import { parseJSONDate } from "src/components/js/statics1";
import betoniClass from "../betoni/betoniClass";

export default class tarjousClass {
  constructor() {
    this.tarjousId = 0;
    this.tarjousNimi = "";
    this.selite = ""; // tarjous selite, sisäiseen käyttöön
    this.tarjousPvm;
    this.laskuttajaAsiakas; // asiakasClass
    this.asiakas; // asiakasClass
    this.startDate;
    this.endDate;
    this.evalCriteria;
    this.evalResultBool;
    this.tarjousRivit = [];
    this.tarjousBetonit = [];
    this.maksuEhtoPv = 21;
    this.viitteenneEval = "";
    this.viitteenneResult = "";
    this.viitteemmeEval = "";
    this.viitteemmeResult = "";
    this.textBeforeEval = "";
    this.textBeforeResult = "";
    this.textAfterEval = "";
    this.textAfterResult = "";
    this.sellerName = "";
    this.tarjous_keikkaId = null;
    this.tarjousKeikka = null;
  }

  initTarjous = async (tarjousJson, token, user, keikkaId = null) => {
    let _tarjousData = null;
    if (tarjousJson.tarjousId > 0) _tarjousData = tarjousJson;
    else _tarjousData = tarjousJson.tarjousData[0];
    this.tarjousRivit = tarjousJson.tarjousRivit || [];
    this.tarjousBetonit = [];

    for (let i = 0; i < tarjousJson.tarjousBetonit?.length; i++) {
      const bc = new betoniClass();
      await bc.loadApiData(tarjousJson.tarjousBetonit[i].keikkaBetoniId, token);
      this.tarjousBetonit.push(bc);
    }
    this.tarjousKeikka = tarjousJson.tarjousKeikka?.[0] || null;

    this.tarjousId = _tarjousData.tarjousId;
    this.tarjousNimi = _tarjousData.tarjousNimi;
    this.tarjousPvm = parseJSONDate(_tarjousData.tarjousPvm);
    this.startDate = parseJSONDate(_tarjousData.startDate);
    this.endDate = parseJSONDate(_tarjousData.endDate);
    this.evalCriteria = _tarjousData.evalCriteria;
    this.evalResultBool = _tarjousData.evalResultBool;
    this.selite = _tarjousData.selite;
    this.maksuEhtoPv = _tarjousData.maksuEhtoPv;
    this.viitteenneEval = _tarjousData.viitteenneEval;
    this.viitteenneResult = _tarjousData.viitteenneResult;
    this.viitteemmeEval = _tarjousData.viitteemmeEval;
    this.viitteemmeResult = _tarjousData.viitteemmeResult;
    this.textBeforeEval = _tarjousData.textBeforeEval;
    this.textBeforeResult = _tarjousData.textBeforeResult;
    this.textAfterEval = _tarjousData.textAfterEval;
    this.textAfterResult = _tarjousData.textAfterResult;
    this.sellerName = _tarjousData.sellerName;
    this.tarjous_keikkaId = _tarjousData.tarjous_keikkaId;
    // fetch asiakas data
    this.laskuttajaAsiakas = (
      await asiakas_fetch(
        user,
        _tarjousData.laskuttajaAsiakasId,
        token,
        null,
        _tarjousData.laskuttajaAsiakasId,
        false,
        true
      )
    )?.globalAsiakas;

    this.asiakas = (
      await asiakas_fetch(
        user,
        _tarjousData.asiakasId,
        token,
        keikkaId,
        _tarjousData.laskuttajaAsiakasId,
        false,
        true
      )
    )?.globalAsiakas;

    return this;
  };
}
